import { combineReducers } from 'redux'
import {
  FETCHING_IP_INFO,
  RECEIVED_IP_INFO,
  ERROR_FETCHING_IP_INFO
} from '../actions/constants/location'

const defaultState = {
  isLoading: false,
  error: false,
  fetched: false,
  json: null,
  city: '',
  region: '',
  position: {
    lat: 0,
    lng: 0
  },
  timestamp: 0,
  countryCode: 'US'
}
const ipInfo = (state = defaultState, action) => {
  switch (action.type) {
    case FETCHING_IP_INFO:
      return {
        ...state,
        isLoading: true
      }
    case RECEIVED_IP_INFO: {
      const { city, region, countryCode, position, json, timestamp } =
        action.data
      return {
        ...state,
        isLoading: false,
        error: false,
        fetched: true,
        json,
        city,
        region,
        countryCode,
        position,
        timestamp
      }
    }
    case ERROR_FETCHING_IP_INFO:
      return {
        ...state,
        isLoading: false,
        fetched: false,
        error: true,
        ...action.data
      }
    default:
      return state
  }
}

const combined = combineReducers({
  ipInfo
})

export default combined
